import React from 'react'

class NavMenuButton extends React.Component{
    render(){
        return(
            <ul>
                <li>
                    <button className='_menu-button' onClick={this.props.onClick} aria-label="menu">
                        <span />
                        <span />
                    </button>
                </li>
            </ul>
        )
    }
}

export default NavMenuButton